import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexLegend,
  ApexPlotOptions,
  ApexStroke,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  ApexResponsive,
  ApexNonAxisChartSeries,
  ApexTitleSubtitle,
  ApexTheme,
  ApexMarkers,
  ApexAnnotations,
  ApexGrid,
} from 'ng-apexcharts';

let primary_color = localStorage.getItem('primary_color') || '#7366ff';
let secondary_color = localStorage.getItem('secondary_color') || '#f73164';

export type ChartOptions = {
  series?: ApexAxisChartSeries;
  chart?: ApexChart;
  xaxis?: ApexXAxis;
  stroke?: ApexStroke;
  tooltip?: any;
  dataLabels?: ApexDataLabels;
  yaxis?: ApexYAxis;
  legend?: ApexLegend;
  labels?: string[];
  plotOptions?: ApexPlotOptions;
  fill?: ApexFill;
  responsive?: ApexResponsive[];
  pieseries?: ApexNonAxisChartSeries;
  title?: ApexTitleSubtitle;
  theme?: ApexTheme;
  colors?: string[];
  markers?: ApexMarkers;
  annotations?: ApexAnnotations;
  grid?: ApexGrid;
};

export let splineArea1: ChartOptions = {
  colors: [primary_color, secondary_color],
  chart: {
    height: 350,
    type: 'area',
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
  },
  xaxis: {
    type: 'datetime',
  },
  tooltip: {
    x: {
      format: 'dd/MM/yy',
    },
  },
};

export const FEATURED_MATERIAL = {
  NO: 0,
  YES: 1,
};

export const TYPE_MATERIAL = {
  VIDEO: 'video',
  IMAGE: 'imagen',
};

export const COLUMNS_CS_MATERIAL_PROMOTIONAL_TABLE = [
  {
    name: 'Acciones',
  },
  {
    name: 'Nombre',
  },
  {
    name: 'Descripcion',
  },
];
export const COLUMNS_REPORT_PREDICTION_TABLE = [
  // {
  //   name: 'Acciones',
  // },
  {
    name: 'Jugador',
  },
  {
    name: 'Nombre y Apellidos',
  },
  {
    name: 'Celular',
  },
  {
    name: 'Bono Ganado',
  },
  {
    name: 'Plantilla',
  },
  {
    name: 'Detalles',
  },
];

export const COLUMNS_REPORT_DETAILS_TABLE = [
  {
    name: 'Pregunta',
  },
  {
    name: 'Respuesta',
  },
  {
    name: 'Opción Correcta',
  },
  {
    name: 'Valor Bono',
  },
];

export const COLUMS_REFERRAL_TABLE = [
  { name: 'Actions' },
  { name: 'Affiliates.ReferralLink.Title' },
  { name: 'Afiliado' },
  { name: 'Affiliates.ReferralLink.Placement' },
  { name: 'Affiliates.ReferralLink.Link' },
  { name: 'Affiliates.ReferralLink.SocialNetwork' },
  { name: 'Affiliates.ReferralLink.Code' },
  { name: 'Affiliates.Table.VisitTraffic' },
  { name: 'Affiliates.Table.GeneralTraffic' },
  { name: 'Affiliates.Table.RegistationTraffic' },
  { name: 'Affiliates.ReferralLink.Status' },
  { name: 'common.createdDate' },
];

export const COLUMNS_PLACEMENTS_TABLE = [
  { name: 'Nombre del lugar' },
  { name: 'País' },
  { name: 'Provincia' },
  { name: 'Ciudad' },
  { name: 'Acciones' },
];

export const SELECT_TIPES_REFERRAL_Links = [
  { name: 'Players', value: 'Jugador' },
  { name: 'Agents', value: 'Agente' },
];

export const STATUS_OPTIONS = [
  { label: 'common.All', value: '' },
  { label: 'common.Active', value: true },
  { label: 'common.Inactive', value: false },
];

export const SOCIAL_MEDIA_OPTIONS = [
  { label: 'Meta', value: 'meta' },
  { label: 'X (Twitter)', value: 'x' },
  { label: 'TikTok', value: 'tiktok' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'common.Email', value: 'email' },
  { label: 'common.Others', value: 'others' },
];

export const USER_TAB_TYPES = ['affiliates', 'agents'] as const;
